module.exports = __webpack_public_path__ + "media/customizations/woodlandshills/logo-new-74a040befec947054c237e266788e2af.png";